/**
 * Highlight the element by changing its background color.
 * @param  {HTMLElement} node
 */
export default function highlightElementDomUtil (node) {
  node.style.background = 'rgba(0, 0, 0, 0.1)'
}
